import { createContext } from 'react';
import { Task } from 'shared/types/task';

export type MultiTaskHandlersContextProps = {
  openDeleteTasks: (tasks: Task[]) => void;
};

export const MultiTaskHandlersContext =
  createContext<MultiTaskHandlersContextProps>({
    openDeleteTasks: () => {},
  });
